import React, { useState, useEffect } from 'react';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
//import { API, } from 'aws-amplify';
import '../components/estilos.css';
import Moment from 'moment';
import { GetLocaciones, GetLocacionesID, GetRecibaID, GetRecibaSeriales, GetRecibaSerialesID, GetRecibaSerialesMP, GetUbicacion } from '../components/queries/Queries';
import { CSVDownload } from "react-csv";
import { createUbicacion, deleteRecibaSerialesMP, updateLocacion, updateRecibaSeriales, updateRecibaSerialesMP, updateUbicacion } from '../graphql/mutations';
import { RiVolumeOffVibrateFill } from 'react-icons/ri';
import * as xlsx from "xlsx";
import { cambioUbicacionSeriales, ObtenerSeriales } from '../components/queries/DCUbicaciones';
import { marcarMaterialFueradePlanta } from '../components/queries/Mutations';
import { generateClient } from "aws-amplify/api";

const API = generateClient();

const initialfFormState = { formType: 'Almacén' }
export default function useAlmacen() {
    //Declaración de variables    
    const [reciba, setReciba] = useState([]);
    const [recibaSinFiltro, setRecibaSinFiltro] = useState([]);
    const [mRecibas, setMRecibas] = useState([]);
    const [formState, updateFormState] = useState(initialfFormState);
    const [estadoReciba, setEstadoReciba] = useState("todos");
    const [search, setSearch] = useState("");
    const [searchBy, setSearchBy] = useState("cliente");
    const [totalRecords, setTotalRecords] = useState(0);
    const { formType } = formState;
    const [mensajeAlert, setMensajeAlert] = useState("Hola");
    const [color, setColor] = useState("warning");
    const userName = window.$name;
    const ppalmacen = window.$Almacen ? window.$Almacen : false;
    const vpreciounitario = window.$VerPrecioUnitario ? window.$VerPrecioUnitario : false;
    const ppalmacenDInventario = window.$AlmacenDInventario ? window.$AlmacenDInventario : false;
    const ppalmacenMEmbarcado = window.$MarcarEmbarcadoAlmacen ? window.$MarcarEmbarcadoAlmacen : false;
    const [aVisible, setAVisible] = useState(false);
    const [cargando, setCargando] = useState(false);
    const [vistaUltimoAP, setVistaUltimoAP] = useState(false);
    const [vistaNumeroParte, setVistaNumeroParte] = useState(false);
    const onDismiss = () => setAVisible(false);
    const [inputList, setInputList] = useState([]);
    const [activeTab, setActiveTab] = useState('1');
    const [packings, setPackings] = useState(1);
    const [locaciones, setLocaciones] = useState([]);

    Moment.locale('en');
    var now = new Date();

    const toggle1 = tab => {
        if (activeTab !== tab) setActiveTab(tab);
        if (tab > 1) setAVisible(false);
    }

    // current page
    const [currentPage, setCurrentPage] = useState(1);

    // total records per page to display   
    const [recordPerPage, setRecordPerPage] = useState(20);

    // range of pages in paginator
    const pageRange = 5;

    // handle change event
    function handlePageChange(pageNumber) {
        setAVisible(false);
        setCargando(false);
        setCurrentPage(pageNumber);
        busqueda(recibaSinFiltro, estadoReciba, searchBy, search, pageNumber, vistaUltimoAP, vistaNumeroParte, recordPerPage);
    }

    async function busqueda(recibasinf, estadoReciba, searchb, search, currentPage, vistaUAP, vistaNP, recordPerPage) {
        /*setMensajeAlert(Moment(search).format("DD/MM/YYYY"));
        setColor("warning");
        setAVisible(true);*/
        var pag = 1;
        var bandera = 1;
        //Se revisa el tipo de vista que se requiere de los datos
        var recibaFromAPI = vistaUAP === true ? recibasinf.sort((a, b) =>
            a.createdAt < b.createdAt ? 1 : a.createdAt > b.createdAt ? -1 : 0) :
            recibasinf.sort((a, b) => a.createdAt > b.createdAt ? 1 : a.createdAt < b.createdAt ? -1 : 0);

        //Filtrado de datos por la búsqueda y el estado de reciba
        recibaFromAPI = recibaFromAPI.filter(reciba =>
            estadoReciba === "todos" ? reciba.status === reciba.status : reciba.status === estadoReciba).filter(reciba =>
                searchb === "numero de parte" ? reciba.numerodeParte.toLowerCase().includes(search.toLowerCase()) :
                    searchb === "cliente" ? reciba.cliente.toLowerCase().includes(search.toLowerCase()) :
                        searchb === "id de reciba" ? reciba.numero.toLowerCase().includes(search.toLowerCase()) :
                            searchb === "serial" ? reciba.serial.toLowerCase().includes(search.toLowerCase()) :
                                searchb === "serial BTI" ? reciba.serialRecibaBTI ? reciba.serialRecibaBTI.toLowerCase().includes(
                                    search.toLowerCase()) : "".includes(search.toLowerCase()) :
                                    searchb === "paking" ? reciba.packing.toLowerCase().includes(search.toLowerCase()) :
                                        searchb === 'lote' ? reciba.lote.toLowerCase().includes(search.toLowerCase()) :
                                            reciba.fechayHoraDeReciba.includes(Moment(search).format("DD/MM/YYYY")));


        if (vistaNP === true) {
            var recibaANP = [];
            var recibaSOANP = await recibaFromAPI.sort((a, b) =>
                a.numerodeParte > b.numerodeParte ? 1 : a.numerodeParte < b.numerodeParte ? -1 : 0);

            var concadID = recibaSOANP[0].numero;
            var concadFecha = recibaSOANP[0].fechayHoraDeReciba;
            var sumCantidad = parseInt(recibaSOANP[0].piezasenAlmacen);
            var sumCantidadRecibida = parseInt(recibaSOANP[0].cantidadRecibida);
            var sumCantidadPlaneada = parseInt(recibaSOANP[0].cantidadPlaneada ? recibaSOANP[0].cantidadPlaneada : 0);
            var concadPacking = recibaSOANP[0].packing;
            var concadlote = recibaSOANP[0].lote;
            var concadSerial = recibaSOANP[0].serial;
            var concadSerialBTI = recibaSOANP[0].serialRecibaBTI;
            //var uplaneacion={};

            await Promise.all(recibaSOANP.map(async (reciba, j) => {
                if (recibaSOANP.length > j + 1) {
                    if (reciba.numerodeParte === recibaSOANP[j + 1].numerodeParte && reciba.cliente === recibaSOANP[j + 1].cliente &&
                        reciba.descripcion === recibaSOANP[j + 1].descripcion) {
                        if (!concadID.includes(recibaSOANP[j + 1].numero)) {
                            concadID = concadID + ", " + recibaSOANP[j + 1].numero;
                        }
                        if (!concadFecha.includes(recibaSOANP[j + 1].fechayHoraDeReciba)) {
                            concadFecha = concadFecha + ", " + recibaSOANP[j + 1].fechayHoraDeReciba;
                        }
                        sumCantidad = sumCantidad + parseInt(recibaSOANP[j + 1].piezasenAlmacen);
                        sumCantidadRecibida = sumCantidadRecibida + parseInt(recibaSOANP[j + 1].cantidadRecibida);
                        sumCantidadPlaneada = sumCantidadPlaneada + parseInt(recibaSOANP[j + 1].cantidadPlaneada ? recibaSOANP[j + 1].cantidadPlaneada : 0);

                        if (!concadPacking.includes(recibaSOANP[j + 1].packing)) {
                            concadPacking = concadPacking + ", " + recibaSOANP[j + 1].packing;
                        }
                        if (!concadlote.includes(recibaSOANP[j + 1].lote)) {
                            concadlote = concadlote + ", " + recibaSOANP[j + 1].lote;
                        }
                        if (!concadSerial.includes(recibaSOANP[j + 1].serial)) {
                            concadSerial = concadSerial + ", " + recibaSOANP[j + 1].serial;
                        }
                        if (!concadSerialBTI.includes(recibaSOANP[j + 1].serialRecibaBTI)) {
                            concadSerialBTI = concadSerialBTI + ", " + recibaSOANP[j + 1].serialRecibaBTI;
                        }
                    } else {
                        recibaANP.push({
                            ...reciba, numero: concadID,
                            fechayHoraDeReciba: concadFecha, piezasenAlmacen: sumCantidad, packing: concadPacking,
                            lote: concadlote, serial: concadSerial, serialRecibaBTI: concadSerialBTI, cantidadRecibida: sumCantidadRecibida,
                            cantidadPlaneada: sumCantidadPlaneada
                        });
                        concadID = recibaSOANP[j + 1].numero;
                        concadFecha = recibaSOANP[j + 1].fechayHoraDeReciba;
                        sumCantidad = parseInt(recibaSOANP[j + 1].piezasenAlmacen);
                        sumCantidadRecibida = parseInt(recibaSOANP[j + 1].cantidadRecibida);
                        sumCantidadPlaneada = parseInt(recibaSOANP[j + 1].cantidadPlaneada ? recibaSOANP[j + 1].cantidadPlaneada : 0);
                        concadPacking = recibaSOANP[j + 1].packing;
                        concadlote = recibaSOANP[j + 1].lote;
                        concadSerial = recibaSOANP[j + 1].serial;
                        concadSerialBTI = recibaSOANP[j + 1].serialRecibaBTI;
                    }
                } else {
                    recibaANP.push({
                        ...reciba, numero: concadID,
                        fechayHoraDeReciba: concadFecha, piezasenAlmacen: sumCantidad, packing: concadPacking,
                        lote: concadlote, serial: concadSerial, serialRecibaBTI: concadSerialBTI, cantidadRecibida: sumCantidadRecibida,
                        cantidadPlaneada: sumCantidadPlaneada
                    });
                }

                return reciba;
            }));

            recibaFromAPI = recibaANP.sort((a, b) =>
                a.cliente > b.cliente ? 1 : a.cliente < b.cliente ? -1 : 0);;
        }
        await Promise.all(recibaFromAPI.map(async reciba => {
            //producto.indexnum=bandera;            
            const restFechas = (new Date()).getTime() - (new Date(reciba.fechaDeReciba)).getTime();
            reciba.FEPlanta = Math.round(restFechas / (1000 * 60 * 60 * 24));
            reciba.indexpag = pag;
            bandera++;
            if (bandera > recordPerPage) {
                bandera = 1;
                pag++;
            }

            return reciba;
        }))

        const lengthreciba = recibaFromAPI.length;
        if (lengthreciba <= 0)
            setCurrentPage(1);

        setReciba(recibaFromAPI.filter(reciba => reciba.indexpag === currentPage));
        setTotalRecords(lengthreciba);

        if (currentPage > 1 && lengthreciba > 0) {
            const prepaginas = parseInt(lengthreciba / recordPerPage);
            const paginas = prepaginas * recordPerPage < lengthreciba ? prepaginas + 1 : prepaginas;
            if (currentPage > paginas) {
                setCurrentPage(paginas);
                const recibaFromAPIp = recibaFromAPI.filter(reciba =>
                    reciba.indexpag === paginas);
                setReciba(recibaFromAPIp);
            }
        }
    }

    //Método useEffect
    useEffect(() => {
        fetchAlmacen();
        fetchLocacionDisponible();
    }, []);

    //Obtiene los datos guardados de Locación
    async function fetchLocacionDisponible() {
        let filter = {
            activo: {
                eq: true,
            },
            ocupado: {
                eq: false,
            },
        };

        //Se obtienen las locaciones
        const apiData = await GetLocaciones(filter);
        const locacionesFromAPI = await apiData.sort((a, b) =>
            a.orden > b.orden ? 1 : a.orden < b.orden ? -1 : 0
        );

        setLocaciones(locacionesFromAPI);
    }
    //Obtiene los datos guardados de Almacen
    async function fetchAlmacen() {
        setCargando(true);
        let filter = {
            and: [{
                activo: {
                    eq: true
                }
            },
            {
                piezasenAlmacen: {
                    gt: 0
                }
            }
            ]
        }


        //Obtiene los datos de los seriales, filtrados por piezasenAlmacen
        const apiData = await GetRecibaSerialesMP(filter);

        const recibaFromAPI = apiData.sort((a, b) =>
            a.createdAt < b.createdAt ? 1 : a.createdAt > b.createdAt ? -1 : 0);
        setRecibaSinFiltro(recibaFromAPI);
        busqueda(recibaFromAPI, estadoReciba, searchBy, search, currentPage, vistaUltimoAP, vistaNumeroParte, recordPerPage);
        setCargando(false);
    }
    async function clicDescargarDatos() {
        setCargando(true);
        setAVisible(false);
        //Declaración de variables
        var almacenEXP = [];
        var recibaPD = recibaSinFiltro;
        //Se ordenan los datos de la reciba por fecha de reciba
        recibaPD = recibaPD.sort((a, b) => a.fechaDeReciba > b.fechaDeReciba
            ? 1 : a.fechaDeReciba < b.fechaDeReciba ? -1 : 0
        );
        //Se obtienen los datos en el orden requerido
        await Promise.all(
            recibaPD.map((recibaf) => {

                //Se agregan los datos de la reciba
                almacenEXP.push({
                    RECIBA: recibaf.numero,
                    CLIENTE: recibaf.cliente,
                    FECHA: Moment(recibaf.fechaDeReciba).format("DD-MM-YYYY"),
                    //HORA: Moment(recibaf.fechayHoraDeReciba).format("HH:mm"),
                    ESTATUS: recibaf.status,
                    PACKING: recibaf.packing,
                    "NÚMERO DE PARTE": recibaf.numerodeParte,
                    LOTE: recibaf.lote,
                    SERIAL: recibaf.serial,
                    "SERIAL BTI": recibaf.serialRecibaBTI,
                    DESCRIPCIÓN: recibaf.descripcion,
                    "CANTIDAD RECIBIDA": recibaf.cantidadRecibida,
                    "PIEZAS EN ALMACÉN": recibaf.piezasenAlmacen,
                    "CONTENEDOR DE RECIBA": recibaf.materialEnCantidad + " " + (recibaf.materialEnCantidad > 1 ?
                        recibaf.materialEn === "caja" ? "cajas" : "contenedores" : recibaf.materialEn),
                    RECIBIÓ: recibaf.Reg_Ins_Usuario,
                    COMENTARIOS: recibaf.comentariosdeinspeccion,
                });

                //


                //return reciba
            })
        );

        var worksheet = xlsx.utils.json_to_sheet(almacenEXP);
        var workbook = xlsx.utils.book_new();
        xlsx.utils.book_append_sheet(workbook, worksheet, "Almacén");
        xlsx.writeFile(
            workbook,
            "Material en almacén " + Moment(new Date()).format("DD-MM-YYYY") + "  " + Moment(new Date()).format("HH:mm") + ".xlsx"
        );
        setCargando(false);
    }
    function palmacen() {
        setInputList([]);
        setMRecibas({ ...reciba });
        updateFormState(() => ({ ...formState, formType: "Almacén" }));
    }

    function buscarpor(e) {
        setAVisible(false);
        setSearchBy(e.target.value);
        if (search && e.target.value !== "fecha")
            busqueda(recibaSinFiltro, estadoReciba, e.target.value, search, currentPage, vistaUltimoAP, vistaNumeroParte, recordPerPage);
    }
    function onSearch(e) {
        setAVisible(false);
        busqueda(recibaSinFiltro, estadoReciba, searchBy, search, currentPage, vistaUltimoAP, vistaNumeroParte, recordPerPage);
    }
    function onSearchFecha(e) {
        setAVisible(false);
        setSearch(e.target.value);
        busqueda(recibaSinFiltro, estadoReciba, searchBy, e.target.value, currentPage, vistaUltimoAP, vistaNumeroParte, recordPerPage);
    }
    //Ordena los  packings de la lista de recibas
    function obtenerPacking(list) {
        var listPacking = [];
        var packings = "";
        var packingsn = 1;

        list.map((packing, i) => {
            if (packings !== packing.packing) {
                listPacking.push({ packing: packing.packing, packingindex: packingsn });
                packingsn = packingsn + 1;
                packings = packing.packing;
            }
        });
        setPackings(packingsn);
        return listPacking
    }
    //Ordena los seriales de la lista de recibas tomando en cuenta los packings
    function obtenerSerialesMostrar(list, packings, idSerial) {
        var seriallist = [];
        var sombra = true;
        packings.map((packing, i) => {
            sombra = !sombra;
            list.map((serial) => {
                if (serial.packing === packing.packing) {
                    serial.sombreado = sombra;
                    seriallist.push(serial);
                    serial.locacionOriginal = serial.locacion;
                }
                if (serial.id === idSerial)
                    serial.sombreado = true;
                else
                    serial.sombreado = false;
            });
        });
        return seriallist
    }

    //Obtiene los datos guardados de Reciba por ID
    async function fetchRecibaporID(recibaID) {
        //Se obtiene la reciba por ID
        const recibaFromAPI = await GetRecibaID(recibaID);
        return recibaFromAPI;
    }

    //Obtiene los datos guardados de Reciba por ID
    async function fetchRecibaSerialporID(recibaID) {
        //Se obtiene la reciba por ID
        const recibaFromAPI = await GetRecibaID(recibaID);
        //Obteniendo los datos de los seriales/contenedores        
        const dataSeriales = await ObtenerSeriales(recibaFromAPI.serialesID)//GetRecibaSeriales(filter);
        const recibaSerialesFromAPI = dataSeriales.sort((a, b) =>
            a.createdAt > b.createdAt ? 1 : a.createdAt < b.createdAt ? -1 : 0)
        //setRecibaSerialesSinFiltro(recibaSerialesFromAPI);
        return recibaSerialesFromAPI;
    }

    async function cliclMostrar(reciba) {
        setCargando(true);
        setAVisible(false);
        const listas = await fetchRecibaporID(reciba.recibaID);
        setMRecibas({ ...listas, Reg_Mod_Usuario: userName });
        const seriales = await fetchRecibaSerialporID(reciba.recibaID);
        //await fetchUltimaUbicacion(reciba.recibaID);
        const packings = obtenerPacking(seriales.sort((a, b) =>
            a.packingindex > b.packingindex ? 1 : a.packingindex < b.packingindex ? -1 : 0));
        setInputList(obtenerSerialesMostrar(seriales.sort((a, b) =>
            a.numerodeParte > b.numerodeParte ? 1 : a.numerodeParte < b.numerodeParte ? -1 : 0), packings, reciba.id));
        updateFormState(() => ({ ...formState, formType: "Detalle Reciba " + reciba.numero }));
        setCargando(false);
    }
    function obtenerUltimaUbicaciont(ubicacion) {
        var uUbicacion = "";
        var uLocacion = "";
        var uCantidad = "";
        var uEspacio = "";
        return <>
            <Table className="bordersubtabla">
                <Thead>
                    <Tr>
                        <Th className="subtablah bordersubtabla">Ubic.</Th>
                        <Th className="subtablah bordersubtabla">Loc.</Th>
                        <Th className="subtablah bordersubtabla">Pzs.</Th>
                        <Th className="subtablah bordersubtabla">Esp.</Th>
                    </Tr>
                </Thead>
                <Tbody>
                    {ubicacion && (
                        <>
                            {ubicacion.map(x => (
                                uUbicacion = x.substr(1, x.search(',') - 1).replace('ubicacion=', ''),
                                uLocacion = x.substr(x.search('locacion=') + 8, x.length).substr(1, x.substr(x.search('locacion=') + 8, x.length).search(',') - 1).replace('locacion=', ''),
                                uCantidad = x.substr(x.search('cantidad=') + 8, x.length).substr(1, x.substr(x.search('cantidad=') + 8, x.length).search(',') - 1).replace('cantidad=', ''),
                                uEspacio = x.substr(x.search('espacio=') + 7, x.length).substr(1, x.substr(x.search('espacio=') + 7, x.length).search('}') - 1).replace('espacio=', ''),
                                <Tr>
                                    <Td className="bordersubtabla">{uUbicacion}</Td>
                                    <Td className="bordersubtabla">{uLocacion}</Td>
                                    <Td className={uLocacion ? "bordersubtabla" : "margintopmobil20px bordersubtabla"}>{uCantidad}</Td>
                                    <Td className="bordersubtabla">{uEspacio}</Td>
                                </Tr>

                            ))}
                        </>)}
                </Tbody>
            </Table>
        </>
    }
    //Indicador de vista del más actual al más antigüo
    function onChangescheckVUAP(e) {
        setVistaUltimoAP(e.target.checked);
        busqueda(recibaSinFiltro, estadoReciba, searchBy, search, currentPage, e.target.checked, vistaNumeroParte, recordPerPage);
    }
    //Vista por número de parte
    function onChangescheckVNP(e) {
        setVistaNumeroParte(e.target.checked);
        const hojasporpagina = e.target.checked === true ? 15 : 6;
        setRecordPerPage(hojasporpagina)
        busqueda(recibaSinFiltro, estadoReciba, searchBy, search, currentPage, vistaUltimoAP, e.target.checked, hojasporpagina);
    }
    async function cambioUbicacion(recibaid, ubicacionAnterior, loacionAnterior, ubicacionDestino, locacionDestino, cantidadPiezas) {
        let ufilter = {
            and: [
                {
                    activo: {
                        eq: true,
                    },
                },
                {
                    RecibaSerialesID: {
                        eq: recibaid,
                    },
                },
            ],
        };
        //Se obtienen los datos de ubicación del material que se cambiará de ubicación.
        var ubicacionSinfiltro = await GetUbicacion(ufilter);
        //Si no se obtuvieron ubicaciones, se termina el proceso
        if (!ubicacionSinfiltro[0]) {
            setMensajeAlert(
                "Operación errónea, no existen ubicaciones del registro actual para cambiar la ubicación del material."
            );
            setColor("warning");
            setCargando(false);
            setAVisible(true);
            return;
        }
        const ubicacionFromAPI = ubicacionSinfiltro
            .filter(
                (ubicacion) =>
                    !ubicacion.fechaSalida &&
                    ubicacion.ubicacion === ubicacionAnterior &&
                    ubicacion.locacion === loacionAnterior
            )
            .sort((a, b) => (a.orden > b.orden ? 1 : a.orden < b.orden ? -1 : 0));
        var ultimoAnterior = 0;
        var orden = ubicacionSinfiltro.length + 1;
        if (!ubicacionFromAPI[0]) {
            setMensajeAlert(
                "Operación errónea, no existen ubicaciones del registro actual en " +
                loacionAnterior +
                " sin fecha de salida registrada, para cambiar la ubicación del material."
            );
            setColor("warning");
            setCargando(false);
            setAVisible(true);
            return;
        }
        //Se obtiene la última ubicación del material que no está en loacionAnterior y que no tiene fecha de salida
        var ultimaUbicacion = [];
        const ultimaUbicacionFromAPI = ubicacionSinfiltro
            .filter(
                (ubicacion) =>
                    !ubicacion.fechaSalida && ubicacion.locacion !== loacionAnterior
            )
            .sort((a, b) => (a.orden > b.orden ? 1 : a.orden < b.orden ? -1 : 0));
        await Promise.all(
            ultimaUbicacionFromAPI.map(async (ubicacionb) => {
                ultimaUbicacion.push({
                    ubicacion: ubicacionb.ubicacion,
                    locacion: ubicacionb.locacion,
                    cantidad: ubicacionb.cantidad,
                    espacio: ubicacionb.espacioOcupado,
                });
            })
        );
        //Datos requeridos para registrar la operación
        const fechaSalida = Moment(new Date()).format("YYYY-MM-DD");
        const horaSalida = Moment(new Date()).format("HH:mm");

        var PiezasUbicacion = cantidadPiezas;
        //setMensajeAlert("Obteniebdo datos");
        var ubicacionesm = [];
        await Promise.all(
            ubicacionFromAPI.map(async (ubicacion, i) => {
                if (PiezasUbicacion > 0) {
                    ubicacionesm.push(ubicacion);
                    if (ubicacion.cantidad > PiezasUbicacion) {
                        PiezasUbicacion = 0;
                    } else {
                        PiezasUbicacion = PiezasUbicacion - ubicacion.cantidad;
                    }
                } else {
                    ultimaUbicacion.push({
                        ubicacion: ubicacion.ubicacion,
                        locacion: ubicacion.locacion,
                        cantidad: ubicacion.cantidad,
                        espacio: ubicacion.espacioOcupado,
                    });
                }
            })
        );
        PiezasUbicacion = cantidadPiezas;
        await Promise.all(
            ubicacionesm.map(async (ubicacion, i) => {
                //Se indica fecha y hora de salida al registro en Inspección que corresonde en Producción.
                const cantidadOriginal = ubicacion.cantidad;
                delete ubicacion.createdAt;
                delete ubicacion.updatedAt;
                delete ubicacion.__typename;
                ubicacion.fechaSalida = fechaSalida;
                ubicacion.horaSalida = horaSalida;
                ubicacion.Reg_Mod_Usuario = userName;
                ubicacion.ultimo = false;
                ubicacion.cantidad =
                    cantidadOriginal > PiezasUbicacion
                        ? PiezasUbicacion
                        : cantidadOriginal;
                //setMensajeAlert("Operación errónea; No se pudo guardar la fecha y hora de salida. Cantidad original: " + cantidadOriginal + " PiezasUbicación: " + PiezasUbicacion);//+ JSON.stringify(ubicacion)
                await API.graphql({
                    query: updateUbicacion,
                    variables: { input: ubicacion },
                });
                //Si la cantidad es menor a la cantidad que de piezas en pintado,
                //Se agrega un registro en el sistema con la cantidad que corresponde que debería quedar en Inspección.
                if (cantidadOriginal > PiezasUbicacion) {
                    //Se agrega un nuevo registro de ubicación en la ubicación anterior.
                    if (ubicacionSinfiltro.length > 1 || ultimoAnterior > 0)
                        ultimoAnterior++;
                    delete ubicacion.id;
                    ubicacion.ultimo = false;
                    ubicacion.Reg_Ins_Usuario = userName;
                    ubicacion.ultimoAnterior = ultimoAnterior;
                    ubicacion.orden = orden;
                    //ubicacion.espacio = 0;
                    ubicacion.cantidad = cantidadOriginal - PiezasUbicacion;
                    delete ubicacion.fechaSalida;
                    delete ubicacion.horaSalida;
                    delete ubicacion.Reg_Mod_Usuario;
                    setMensajeAlert(
                        "Operación errónea; Problemas al guardar el registro de ubicación de la cantidad restante."
                    );
                    await API.graphql({
                        query: createUbicacion,
                        variables: { input: ubicacion },
                    });
                    ultimaUbicacion.push({
                        ubicacion: ubicacion.ubicacion,
                        locacion: ubicacion.locacion,
                        cantidad: ubicacion.cantidad,
                        espacio: ubicacion.espacioOcupado,
                    });
                    orden++;
                    PiezasUbicacion = 0;
                } else {
                    PiezasUbicacion = PiezasUbicacion - cantidadOriginal;
                }
                orden++;
            })
        );

        //Se agrega un nuevo registro de ubicación en la ubicación que corresponde.
        const ubicacion = ubicacionesm[0];
        if (ubicacionSinfiltro.length > 1 || ultimoAnterior > 0) ultimoAnterior++;
        delete ubicacion.id;
        ubicacion.fechaIngreso = fechaSalida;
        ubicacion.horaIngreso = horaSalida;
        ubicacion.ubicacion = ubicacionDestino;
        ubicacion.locacion = locacionDestino;
        ubicacion.ubicaciondeReciba = false;
        ubicacion.ultimo = true;
        ubicacion.Reg_Ins_Usuario = userName;
        ubicacion.ultimoAnterior = ultimoAnterior;
        ubicacion.orden = orden;
        ubicacion.espacioOcupado = 0;
        //ubicacion.comentarios = pInspeccion.comentariosInspeccion;
        ubicacion.cantidad = cantidadPiezas;
        delete ubicacion.fechaSalida;
        delete ubicacion.horaSalida;
        delete ubicacion.Reg_Mod_Usuario;
        setMensajeAlert(
            "Operación errónea; Problemas al guardar la nueva ubicación"
        ); //+ JSON.stringify(ubicacion)
        await API.graphql({
            query: createUbicacion,
            variables: { input: ubicacion },
        });
        ultimaUbicacion.push({
            ubicacion: ubicacion.ubicacion,
            locacion: ubicacion.locacion,
            cantidad: ubicacion.cantidad,
            espacio: ubicacion.espacioOcupado,
        });

        //Se agrupan las ubicaciones de última ubicación
        const sUltimaU = ultimaUbicacion.sort((a, b) =>
            a.ubicacion + (a.locacion ? a.locacion : "") >
                b.ubicacion + (b.locacion ? b.locacion : "")
                ? 1
                : a.ubicacion + (a.locacion ? a.locacion : "") <
                    b.ubicacion + (b.locacion ? b.locacion : "")
                    ? -1
                    : 0
        );

        var auxUltimaUbicacion = [];
        var ubicacionLocacionanterior =
            (sUltimaU[0].ubicacion ? sUltimaU[0].ubicacion : "") +
            (sUltimaU[0].locacion ? sUltimaU[0].locacion : "");
        var cantidadTotal = 0;
        var espacio = 0;
        await Promise.all(
            sUltimaU.map(async (ubicacion, i) => {
                const ubicacionLocacion =
                    (ubicacion.ubicacion ? ubicacion.ubicacion : "") +
                    (ubicacion.locacion ? ubicacion.locacion : "");
                if (ubicacionLocacion !== ubicacionLocacionanterior) {
                    auxUltimaUbicacion.push({
                        ubicacion: sUltimaU[i - 1].ubicacion,
                        locacion: sUltimaU[i - 1].locacion,
                        cantidad: cantidadTotal,
                        espacio: espacio,
                    });
                    ubicacionLocacionanterior = ubicacionLocacion;
                    cantidadTotal = 0;
                    espacio = 0;
                }
                cantidadTotal = cantidadTotal + ubicacion.cantidad;
                espacio = espacio + ubicacion.espacio;

                if (i === sUltimaU.length - 1) {
                    auxUltimaUbicacion.push({
                        ubicacion: ubicacion.ubicacion,
                        locacion: ubicacion.locacion,
                        cantidad: cantidadTotal,
                        espacio: espacio,
                    });
                }
            })
        );
        return sUltimaU;
    }
    //Procedimiento especial para marcar el material como embarcado por filtro
    async function marcarEmbarcado() {
        //Declaración de variables auxiliares
        const fechainicial = Moment("2023-03-01").format("YYYY-MM-DD");
        const fechafinal = Moment("2023-03-10").format("YYYY-MM-DD");
        const cliente = "Robertshaw Controls Nuevo Laredo";
        //Filtro por fecha y registro activo
        setCargando(true);
        setAVisible(false);
        var recibaFromAPI = [];
        try {
            let filter = {
                and: [
                    {
                        activo: {
                            eq: true,
                        },
                    },
                    {
                        cliente: {
                            eq: cliente,
                        },
                    },
                    {
                        piezasenAlmacen: {
                            gt: 0,
                        },
                    },
                    /*{
                        serialRecibaBTI: {
                            eq: 'BTI-B3-18098',
                        },
                    },*/
                    {
                        fechaDeReciba: {
                            ge: fechainicial,
                        },
                    },
                    {
                        fechaDeReciba: {
                            le: fechafinal,
                        },
                    },
                ],
            };
            setMensajeAlert("Sin datos");
            const apiData = await GetRecibaSeriales(filter);
            setMensajeAlert("Datos");
            var afectados = 0;
            recibaFromAPI = apiData.sort((a, b) =>
                a.createdAt > b.createdAt ? 1 : a.createdAt < b.createdAt ? -1 : 0
            );
            setMensajeAlert(
                "Datos a afectar descargados: " + JSON.stringify(recibaFromAPI)
            );
            var cambioUbicacionAux = [];
            await Promise.all(
                recibaFromAPI.map(async (recibam) => {
                    if (recibam.piezasenAlmacen > 0) {
                        setMensajeAlert(
                            "Empezando cambios: " + afectados + " " + JSON.stringify(recibam)
                        );
                        var auxUltimaUbicacion = [];
                        const loacionAnterior = "";
                        const ubicacionAnterior = "Almacén";
                        const loacionPiezas = "Embarcado";
                        const ubicacionPiezas = "Embarques";
                        const cantidadPiezas = recibam.piezasenAlmacen;

                        //Se actualizan los datos en reciba Seriales

                        //Piezas Embarcadas que se guardan en recibaSeriales
                        recibam.piezasEmbarcadas = recibam.piezasenAlmacen;

                        if (recibam.fechaDeReciba > "2022-08-15") {
                            /*auxUltimaUbicacion = await cambioUbicacionSeriales(
                                recibam.id,
                                ubicacionAnterior,
                                loacionAnterior,
                                ubicacionPiezas,
                                loacionPiezas,
                                cantidadPiezas
                            );*/
                            cambioUbicacionAux = await cambioUbicacionSeriales(
                                recibam,
                                ubicacionAnterior,
                                loacionAnterior,
                                ubicacionPiezas,
                                loacionPiezas,
                                cantidadPiezas)

                        } else {
                            auxUltimaUbicacion.push({
                                ubicacion: "Embarques",
                                locacion: "Embarcado",
                                cantidad: recibam.piezasEmbarcadas,
                                espacio: 0,
                            });
                        }
                        if (cambioUbicacionAux.mensaje !== "") {
                            return
                        } else {
                            setMensajeAlert(
                                "Después del cambio de ubicación: " +
                                afectados +
                                " " +
                                JSON.stringify(recibam)
                            );
                            auxUltimaUbicacion = cambioUbicacionAux.sUltimaU;

                            //Piezas a embarcar que se guardan en recibaSeriales
                            delete recibam.createdAt;
                            delete recibam.updatedAt;
                            delete recibam.__typename;
                            recibam.piezasenAlmacen = 0
                            recibam.ultimaUbicacion = auxUltimaUbicacion;
                            recibam.rubicaciones = cambioUbicacionAux.sUbicaciones
                            recibam.Reg_Mod_Usuario = userName;
                            setMensajeAlert(
                                "Antes del guardado: " + afectados + " " + JSON.stringify(recibam)
                            );
                            let upRecibaS = await API.graphql({
                                query: updateRecibaSeriales,
                                variables: { input: recibam },
                            });
                            if (recibam.recibaSerialMPID) {
                                //Se actualizan los datos en la tabla de serialesMP o se eliminan segpun corresponda.
                                if (cantidadPiezas === recibam.cantidadRecibida) {
                                    setMensajeAlert("No se pudo eliminar de la tabla temporal; ");
                                    await API.graphql({ query: deleteRecibaSerialesMP, variables: { input: { id: recibam.recibaSerialMPID, } } });
                                } else {
                                    //Se actualizan los datos en recibaSerialesMP
                                    const recibaSerialMPID = recibam.recibaSerialMPID;
                                    delete recibam.recibaSerialMPID;
                                    setMensajeAlert("Operación errónea; Problemas al guardar los datos del serial" + JSON.stringify(recibam));
                                    await API.graphql({ query: updateRecibaSerialesMP, variables: { input: { ...recibam, id: recibaSerialMPID, rsUpdatedAt: upRecibaS.data.updateRecibaSeriales.updatedAt } }, });

                                }
                            }
                            setMensajeAlert(
                                "Después del guardado: " +
                                afectados +
                                " " +
                                JSON.stringify(recibam)
                            );
                            afectados++;
                        }
                    }
                })
            );
            window.scrollTo(0, 0);
            setMensajeAlert("Operación exitosa, se marcaron " + afectados + " de " +
                recibaFromAPI.length + " registros como embarcados, correspondientes a la fecha del: " +
                fechainicial + " al: " + fechafinal + " Serial: " + recibaFromAPI[0].serialRecibaBTI);
            setColor("primary");
            setAVisible(true);
            setCargando(false);
        } catch (e) {
            window.scrollTo(0, 0);
            //setMensajeAlert("No fue posible realizar la operación: revise su conexión a internet y vuelva a intentar, si el problema persiste, favor de comunicarte a sistemas");
            setColor("warning");
            setAVisible(true);
            setCargando(false);
        }
        return (
            <CSVDownload
                data={recibaFromAPI}
                filename={
                    "A embarcar del:  " + fechainicial + " al: " + fechafinal + ".csv"
                }
            />
        );
    }
    //Procedimiento especial para marcar el material como embarcado por reciba
    async function marcarEmbarcadoReciba(recibas) {
        setCargando(true);
        setAVisible(false);
        try {
            //Se obtienen los datos de la reciba por ID        
            const recibam = await GetRecibaSerialesID(recibas.recibaSerialID);
            var cambioUbicacionAux = [];
            if (recibam.id) {
                if (recibam.piezasenAlmacen > 0) {
                    setMensajeAlert(
                        "Empezando cambios: " + JSON.stringify(recibam)
                    );
                    var auxUltimaUbicacion = [];
                    const loacionAnterior = "";
                    const ubicacionAnterior = "Almacén";
                    const loacionPiezas = "Embarcado";
                    const ubicacionPiezas = "Embarques";
                    const cantidadPiezas = recibam.piezasenAlmacen;

                    //Se actualizan los datos en reciba Seriales

                    //Piezas Embarcadas que se guardan en recibaSeriales
                    recibam.piezasEmbarcadas = (recibam.piezasEmbarcadas ? recibam.piezasEmbarcadas : 0) + recibam.piezasenAlmacen;

                    if (recibam.fechaDeReciba > "2022-08-15") {
                        /*  auxUltimaUbicacion = await cambioUbicacion(
                             recibam.id,
                             ubicacionAnterior,
                             loacionAnterior,
                             ubicacionPiezas,
                             loacionPiezas,
                             cantidadPiezas
                         );*/
                        setMensajeAlert("Antes de obtener los datos del cambio de ubicación");
                        cambioUbicacionAux = await cambioUbicacionSeriales(
                            recibam,
                            ubicacionAnterior,
                            loacionAnterior,
                            ubicacionPiezas,
                            loacionPiezas,
                            cantidadPiezas)
                        setMensajeAlert(
                            "Después de obtener los datos del cambio de ubicación: " +
                            JSON.stringify(cambioUbicacionAux)
                        );
                    } else {
                        auxUltimaUbicacion.push({
                            ubicacion: "Embarques",
                            locacion: "Embarcado",
                            cantidad: cantidadPiezas,
                            espacio: 0,
                        });
                    }
                    if (cambioUbicacionAux.mensaje !== "") {
                        setMensajeAlert(cambioUbicacionAux.mensaje);
                        setColor(cambioUbicacionAux.color);
                        setAVisible(true);
                        setCargando(false);
                        return
                    } else {
                        setMensajeAlert(
                            "Después del cambio de ubicación: " +
                            JSON.stringify(recibam)
                        );
                        auxUltimaUbicacion = cambioUbicacionAux.sUltimaU;
                        //Piezas a embarcar que se guardan en recibaSeriales
                        delete recibam.createdAt;
                        delete recibam.updatedAt;
                        delete recibam.__typename;
                        recibam.piezasenAlmacen = 0
                        recibam.ultimaUbicacion = auxUltimaUbicacion;
                        recibam.rubicaciones = cambioUbicacionAux.sUbicaciones
                        recibam.Reg_Mod_Usuario = userName;
                        if (recibam.piezasEmbarcadas >= recibam.cantidadRecibida) {
                            recibam.piezasEnPlanta = false;
                        }
                        setMensajeAlert(
                            "Antes del guardado: " + " " + JSON.stringify(recibam)
                        );
                        let upRecibaS = await API.graphql({
                            query: updateRecibaSeriales,
                            variables: { input: recibam },
                        });
                        if (recibam.recibaSerialMPID) {
                            //Se actualizan los datos en la tabla de serialesMP o se eliminan segpun corresponda.
                            if (cantidadPiezas === recibam.cantidadRecibida) {
                                setMensajeAlert("No se pudo eliminar de la tabla temporal; ");
                                await API.graphql({ query: deleteRecibaSerialesMP, variables: { input: { id: recibam.recibaSerialMPID, } } });
                            } else {
                                //Se actualizan los datos en recibaSerialesMP
                                const recibaSerialMPID = recibam.recibaSerialMPID;
                                delete recibam.recibaSerialMPID;
                                setMensajeAlert("Operación errónea; Problemas al guardar los datos del serial" + JSON.stringify(recibam));
                                await API.graphql({ query: updateRecibaSerialesMP, variables: { input: { ...recibam, id: recibaSerialMPID, rsUpdatedAt: upRecibaS.data.updateRecibaSeriales.updatedAt } }, });

                            }
                        }
                        setMensajeAlert(
                            "Después del guardado: " +
                            JSON.stringify(recibam)
                        );
                        if ((recibam.locacion ? recibam.locacion : "") != "") {
                            //Se obtiene el registro de la locación a liberar
                            const locacionae = await GetLocaciones({
                                and: [{ locacion: { eq: recibam.locacion, }, },
                                { activo: { eq: true, }, },
                                { recibaSerialID: { eq: recibam.id, }, },
                                { ocupado: { eq: true, }, }]
                            });
                            if (locacionae[0]) {
                                delete locacionae[0].createdAt;
                                delete locacionae[0].updatedAt;
                                delete locacionae[0].__typename;
                                locacionae[0].Reg_Mod_Usuario = userName;
                                locacionae[0].ocupado = false;
                                locacionae[0].fechaDeliberacion = new Date();
                                locacionae[0].recibaSerialID = "";
                                locacionae[0].recibaSerialMPID = "";
                                locacionae[0].espacioOcupado = 0;
                                await API.graphql({
                                    query: updateLocacion,
                                    variables: { input: locacionae[0] },
                                });

                            }
                        }
                    }
                }
                window.scrollTo(0, 0);
                setMensajeAlert("Operación exitosa, se marcó como embarcado el serial " + recibam.serialRecibaBTI + " de la reciba " + recibam.numero);
                setColor("primary");;
            } else {
                window.scrollTo(0, 0);
                setMensajeAlert("No se encontraron datos para marcar como embarcados, si el problema persiste, favor de comunicarte a sistemas");
                setColor("warning");
            }
            setAVisible(true);
            setCargando(false);
            fetchAlmacen();
        } catch (e) {
            window.scrollTo(0, 0);
            //setMensajeAlert("No fue posible realizar la operación: revise su conexión a internet y vuelva a intentar, si el problema persiste, favor de comunicarte a sistemas");
            setColor("warning");
            setAVisible(true);
            setCargando(false);
        }
    }
    //Procedimiento especial para marcar el material fuera de planta
    async function marcarFueradePlanta(recibas) {
        setCargando(true);
        setAVisible(false);
        window.scrollTo(0, 0);
        try {
            //Se obtienen los datos de la reciba por ID        
            const mfp = await marcarMaterialFueradePlanta(recibas, userName);
            setMensajeAlert(mfp.mensaje);
            setColor(mfp.color);
            setAVisible(true);
            setCargando(false);
            fetchAlmacen();
        } catch (e) {
            window.scrollTo(0, 0);
            setMensajeAlert(e.message);
            setColor("warning");
            setAVisible(true);
            setCargando(false);
        }
    }
    //Obtiene los datos guardados de Locación
    async function LocacionOcupada(ID) {
        //Decaración de variables auxiliares
        var ocupado = false;
        //Se obtienen los datos de las locaciones ocupadas
        const locacionesFromAPI = await GetLocacionesID(ID);
        //Se revisa si el registro que se obutvo está marcado como ocupado
        if (locacionesFromAPI.ocupado === true) {
            ocupado = true;
        }

        return ocupado;
    }
    async function managelocacion(recibaSerial, anterior, actual, name, index, list, espacio) {
        //setMensajeAlert("Anterior " + anterior + "Actual " + actual + "Name " + name + "Index " + index + "Espacio " + espacio );
        //setMensajeAlert(<div style={{ marginTop: 20 }}>{JSON.stringify(actualLocacion[0])}</div>);
        //setColor("warning");
        //setAVisible(true);
        setCargando(true);
        try {
            // Revisa si la locación actual es diferente a vacio
            if (actual !== "") {
                //Se revisa si la locación elegida no se encuentra ocupada
                //Se obtiene el registro de la locación actual
                const actualLocacion = locaciones.filter(
                    (locacion) => locacion.locacion === actual
                );
                //Si existen registros de la locación actual
                if (actualLocacion[0]) {
                    if ((await LocacionOcupada(actualLocacion[0].id)) === false) {
                        delete actualLocacion[0].createdAt;
                        delete actualLocacion[0].updatedAt;
                        delete actualLocacion[0].__typename;
                        actualLocacion[0].Reg_Mod_Usuario = userName;
                        actualLocacion[0].ocupado = true;
                        actualLocacion[0].fechaDeOcupacion = new Date();
                        actualLocacion[0].recibaSerialID = recibaSerial.recibaSerialID;
                        actualLocacion[0].recibaSerialMPID = recibaSerial.id
                        actualLocacion[0].espacioOcupado = 1;
                        await API.graphql({
                            query: updateLocacion,
                            variables: { input: actualLocacion[0] },
                        });
                        //Se obtienen los datos de recibaSeriales y se actualiza la locación
                        const recibaSerialA = await GetRecibaSerialesID(recibaSerial.recibaSerialID);
                        delete recibaSerialA.createdAt;
                        delete recibaSerialA.updatedAt;
                        delete recibaSerialA.__typename;
                        recibaSerialA.locacion = actual;
                        recibaSerial.espacioOcupado = 1;
                        let upRecibaS = await API.graphql({
                            query: updateRecibaSeriales,
                            variables: { input: recibaSerialA },
                        });
                        if (recibaSerialA.recibaSerialMPID) {
                            const recibaSerialMPID = recibaSerialA.recibaSerialMPID;
                            delete recibaSerialA.recibaSerialMPID;
                            await API.graphql({
                                query: updateRecibaSerialesMP,
                                variables: { input: { ...recibaSerialA, id: recibaSerialMPID, rsUpdatedAt: upRecibaS.data.updateRecibaSeriales.updatedAt } },
                            });
                        }
                        list[index][name] = actual;
                        list[index]["espacioOcupado"] = 1;
                        setReciba(list);
                        /* await fetchLocacionDisponible();
                                     await setMensajeAlert("La locación '" + actual + "' se guardó con éxito");   */
                    } else {
                        setMensajeAlert(
                            "La locación '" + actual +
                            "' ya se encuentra ocupada, elige otra locación por favor"
                        );
                        //setMensajeAlert(<div style={{ marginTop: 20 }}>{JSON.stringify(actualLocacion[0])}</div>);
                        setColor("warning");
                        setAVisible(true);
                        window.scrollTo(0, 0);
                    }
                }
            } else {
                list[index][name] = actual;
                list[index].espacioOcupado = 0;

                //Se obtienen los datos de recibaSeriales y se actualiza la locación
                const recibaSerialA = await GetRecibaSerialesID(recibaSerial.recibaSerialID);
                delete recibaSerialA.createdAt;
                delete recibaSerialA.updatedAt;
                delete recibaSerialA.__typename;
                recibaSerialA.locacion = actual;
                recibaSerial.espacioOcupado = 0;
                let upRecibaS = await API.graphql({
                    query: updateRecibaSeriales,
                    variables: { input: recibaSerialA },
                });
                if (recibaSerialA.recibaSerialMPID) {
                    const recibaSerialMPID = recibaSerialA.recibaSerialMPID;
                    delete recibaSerialA.recibaSerialMPID;
                    await API.graphql({
                        query: updateRecibaSerialesMP,
                        variables: { input: { ...recibaSerialA, id: recibaSerialMPID, rsUpdatedAt: upRecibaS.data.updateRecibaSeriales.updatedAt } },
                    });
                }
            }
            //Si la fecha anterior es diferente a vacío y la locación actual y anterior es diferente, se libera la locación anterior
            if (anterior !== "" && actual !== anterior) {
                //Se libera la locación anterior
                let filter = {
                    and: [
                        {
                            locacion: {
                                eq: anterior,
                            },
                        },
                        {
                            activo: {
                                eq: true,
                            },
                        }
                    ]
                };
                //Se obtiene el registro de la locación a liberar
                const locacionae = await GetLocaciones(filter);
                if (locacionae[0]) {
                    delete locacionae[0].createdAt;
                    delete locacionae[0].updatedAt;
                    delete locacionae[0].__typename;
                    locacionae[0].Reg_Mod_Usuario = userName;
                    locacionae[0].ocupado = false;
                    locacionae[0].fechaDeliberacion = new Date();
                    locacionae[0].recibaSerialID = "";
                    locacionae[0].recibaSerialMPID = "";
                    locacionae[0].espacioOcupado = 0;
                    await API.graphql({
                        query: updateLocacion,
                        variables: { input: locacionae[0] },
                    });
                }
            }


            //Obtención de locaciones disponibles             
            fetchLocacionDisponible();
            //Mensaje de resultado de la operación            
            setCargando(false);
            window.scrollTo(0, 0);
            setMensajeAlert("Asignación/Cambio de ubicación realizada de manera exitosa");
            setColor("info");
            setAVisible(true);
        } catch (e) {
            window.scrollTo(0, 0);
            setMensajeAlert("Hay problemas registrando las locaciones");
            setColor("warning");
            setAVisible(true);
            //fetchLocacionDisponible();
        }
        // const anteriorLocacion = locaciones.filter(locacion =>locacion.locacion===actual);
    }
    return {
        ppalmacenDInventario,
        ppalmacenMEmbarcado,
        ppalmacen,
        vpreciounitario,
        formType,
        color,
        aVisible,
        mensajeAlert,
        cargando,
        activeTab,
        searchBy,
        search,
        reciba,
        currentPage,
        recordPerPage,
        totalRecords,
        pageRange,
        mRecibas,
        inputList,
        userName,
        vistaNumeroParte,
        locaciones,
        clicDescargarDatos,
        marcarEmbarcado,
        marcarEmbarcadoReciba,
        marcarFueradePlanta,
        onDismiss,
        palmacen,
        toggle1,
        buscarpor,
        setSearch,
        onSearchFecha,
        handlePageChange,
        onSearch,
        onChangescheckVUAP,
        onChangescheckVNP,
        fetchAlmacen,
        obtenerUltimaUbicaciont,
        cliclMostrar,
        managelocacion,
    }
}